import React from "react"
import { getCart } from "../../../../../stores/CartStateStore"
import ItemPrice from "../../../../../ui-components/ItemPrice"

import styles from "./WalletForm.module.scss"

// ----------------------------------------------------------------------------

export default function WalletForm(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { cartState, wallet, onClick, isCashSelected = false } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  let walletDisabled = wallet.enabled === false

  let cart = getCart(cartState)
  let remainingAmount =
    (wallet.available_amount_cents - cart.wallet_used_amount_cents) / 100

  let amount = walletDisabled ? wallet.available_amount_cents : cart.wallet_used_amount_cents

  // -------------------------------------

  return (
    <>
      <div
        className={`${styles.container} fr-margin-top-base`}
        onClick={!walletDisabled ? onClick : null}
      >
        <div
          className="row"
          style={isCashSelected || walletDisabled ? { opacity: 0.5 } : {}}
        >
          <div className="col-xs-7 col-md-9">
            <span className="fr-p2 fr-normal">
              {I18n.t("wallet.checkout.title")}
            </span>
            <span className={`fr-p2 fr-normal fr-light ${styles.description}`}>
              {I18n.t("wallet.checkout.fr_credits")}
            </span>
          </div>
          <div className="col-xs-5 col-md-3 fr-margin-top-small">
            <div className={styles.priceContainer}>
              <ItemPrice
                className={styles.redPrice}
                priceCents={amount}
              />
              <i className="fal fa-wallet fr-h4 fr-light fr-margin-left-xsmall"></i>
            </div>
          </div>
        </div>
      </div>
      {remainingAmount > 0 && !walletDisabled && (
        <div>
          <p className="fr-p3 fr-italic fr-margin-top-small fr-margin-left-small">
            {I18n.t("wallet.checkout.remaining_amount", {
              amount: remainingAmount.toFixed(2),
            })}
          </p>
        </div>
      )}
      {walletDisabled && (
        <div>
          <p className="fr-p3 fr-italic fr-margin-top-small fr-margin-left-small">
            {I18n.t("wallet.checkout.wallet_disabled")}
          </p>
        </div>
      )}
    </>
  )
}
